import { addMinutes, format, differenceInDays } from "date-fns";
import _ from "lodash";

export const convertStringToStartCase = (stringToBeConverted) => {
  return _.startCase(stringToBeConverted);
};

export const convertStringToKebabCase = (stringToBeConverted) => {
  return _.kebabCase(stringToBeConverted);
};

export const addMinutesToTime = (addMinutesTo, valueToBeAdded): string => {
  const targetTime = new Date("01/01/2021 " + addMinutesTo);
  const newTime = addMinutes(targetTime, valueToBeAdded);

  return newTime;
};

export const subtractDates = (date1, date2) => {
  // Make sure date1 and date2 are valid Date objects
  if (!(date1 instanceof Date) || !(date2 instanceof Date)) {
    throw new Error("Both inputs must be valid Date objects.");
  }

  // Calculate the difference in days
  const daysDifference = differenceInDays(date1, date2);

  return daysDifference;
};

export const formatDate = (dateToFormat = new Date()) => {
  return format(new Date(), "yyyy-MM-dd");
};

export const calculateLoanMonthlyAmortization = (
  loanAmount,
  loanTerm,
  ratePerMonthInDecimal
) => {
  const part1 = Number(loanAmount) * ratePerMonthInDecimal;
  const part2 = Number(loanAmount) / Number(loanTerm);

  return part2 + part1;
};

export const checkIfAnArrayContainsSomeOfTheItemsOfAnotherArray = (
  array1: Array<any>,
  array2: Array<any>
): boolean => {
  const containsAny = array1.some((value) => array2.includes(value));
  return containsAny;
};

export const checkIfAnObejctContainsSomeOfTheItemsOfAnArray = (
  objectToCheck: Array<any>,
  arrayContainer: Array<any>
): boolean => {
  const containsAny = arrayContainer.some((key) =>
    Object.keys(objectToCheck).includes(key)
  );
  return containsAny;
};

export const arrangeArrayOfStringAlphabetically = (
  arrayToBeSorted,
  objectProperty = ""
) => {
  if (objectProperty === "") {
    return arrayToBeSorted.sort((a, b) => a.localeCompare(b));
  }

  return arrayToBeSorted.sort((a, b) =>
    a[objectProperty].localeCompare(b[objectProperty])
  );
};

/**
 * Shuffles array in place. ES6 version
 * @param {Array} a items An array containing the items.
 */
export const shuffleArray = (a) => {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

export const checkIfAllItemsWithinAnArrayOfObjectContainsTheSameValueOfASpecificField =
  (arr, field) => {
    if (arr.length === 0) {
      return false; // Return false if the array is empty
    }

    const referenceValue = arr[0][field]; // Get the reference value from the first object

    // Check if all objects have the same value in the specified field
    return arr.every((obj) => obj[field] === referenceValue);
  };
export const commmaSeparatedNumericAmount = (value = "") => {
  let removedComma = value.replace(",", "");
  let removedNonNumber = removedComma.replace(/[^0-9]/g, ""); //to remove unnecessary symbols and letters and period

  removedNonNumber =
    removedNonNumber.length > 10
      ? removedNonNumber.substring(0, 10)
      : removedNonNumber; //this is to limit the input to only 10 numerical limits

  if (removedNonNumber != "") {
    removedNonNumber = parseFloat(removedNonNumber);
  }
  let commaSeparated = removedNonNumber
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return commaSeparated;
};

export const moveArrayItemToFront = (array, item) => {
  // Find the index of the item
  var index = array.indexOf(item);

  // If the item exists in the array
  if (index !== -1) {
    // Remove the item from its current position
    array.splice(index, 1);

    // Insert the item at the beginning of the array
    array.unshift(item);
  }
};

export const moveArrayItemToFrontByProperty = (
  array,
  propertyName,
  propertyValue
) => {
  // Find the index of the item with the matching property value
  var index = array.findIndex((item) => item[propertyName] === propertyValue);

  // If the item exists in the array
  if (index !== -1) {
    // Remove the item from its current position
    var item = array.splice(index, 1)[0];

    // Insert the item at the beginning of the array
    array.unshift(item);
  }
};

export const reverseArray = (arr = []) => {
  arr.reverse();
};

export const removenonNumber = (str) => {
  if (str === null || str === undefined) {
    return "";
  }
  let removedNonNumber = str.replace(/[^0-9]/g, "");
  return removedNonNumber;
};

export const countDigits = (str) => {
  const regex = /\d/g;
  const matches = str.match(regex);
  return matches ? matches.length : 0;
};

export const filterLocation = (
  val,
  listStores,
  setPreferredLocation,
  setListMunicipality,
  setStores
) => {
  const filteredMunicipality = listStores.filter((a) => a.location === val);
  const municipality = [
    ...new Set(filteredMunicipality.map((store) => store.municipality)),
  ];
  setPreferredLocation(val);
  setListMunicipality(municipality);
  setStores(filteredMunicipality);
};

export const handleSelectChange = (
  selectedOption,
  formErrors,
  setFormErrors,
  form,
  setForm
) => {
  console.log(selectedOption);
  setFormErrors({
    ...formErrors,
    preferredStore: selectedOption === "" ? "EastWest Branch is required" : "",
  });
  setForm({ ...form, preferredStore: selectedOption ? selectedOption : null });
};

export const filterStore = (listStores, preferredMunicipality, setStores) => {
  const filteredStore = listStores.filter(
    (a) => a.municipality === preferredMunicipality
  );
  setStores(filteredStore);
};

export const filterStoreBusiness = (
  val,
  listStores,
  setPreferredMunicipality,
  setStores
) => {
  const filteredStore = listStores.filter((a) => a.municipality === val);
  setPreferredMunicipality(val);
  setStores(filteredStore);
};
